import React from "react";
import AdmissionForm from "../../components/forms/Student/Admission"
import Footer from "../../components/Footer";
import NavBar from "../../components/navbar-components/NavBar";

const Admission = () => {
    return (
        <>
        <NavBar/>
        <div className="bg-gray-200 py-5">
            <AdmissionForm/>
        </div>
        <Footer/>
        </>
    )
}

export default Admission